import React from "react";
import {
  Dialog as MuiDialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  title: string;
  children: React.ReactNode;
  actions: React.ReactNode;
  onClose: () => void;
  open: boolean;
}

export const Dialog: React.FC<Props> = ({
  title,
  children,
  actions,
  onClose,
  open,
}) => {
  return (
    <MuiDialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle variant="h4">
        {title}
        <IconButton
          aria-label="close"
          data-testid="dialog-close-btn"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "grey.500",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ margin: 0, padding: 0 }}>{children}</DialogContent>
      <DialogActions>{actions}</DialogActions>
    </MuiDialog>
  );
};
